import React from 'react';
import { ClassValue } from 'classnames/types';
import styles from './Ingress.module.scss';
import Typography, { SupportedTagName, TypographyProps } from '../Typography';
import { ArrayElementType } from '../../../types/utils/ArrayElementType';

type IngressProps<T extends SupportedTagName> = {
  /** Modifier for the font size. Ingress font sizes don't scale according to the screen size */
  size?: SupportedIngressSize;
  /** Allowed colors for Ingress */
  color?: SupportedIngressColor;
} & Omit<TypographyProps<T>, 'color' | 'uppercase' | 'font'>;
// Alias for backwards compatibility
export type IngressAttributes = IngressProps<SupportedTagName>;

function Ingress<T extends SupportedTagName>({
  tagName,
  size = 'lg',
  color = 'gray500',
  className,
  fontWeight = 'medium',
  children,
  ...props
}: IngressProps<T>) {
  const classNames: ClassValue = [
    styles[`ingress__size_${size.toLowerCase()}`],
    className,
  ];

  return (
    <Typography
      {...props}
      tagName={tagName as SupportedTagName} // this circumvents some weird ts problem
      font="teliasans"
      uppercase={false}
      color={color}
      className={classNames}
      fontWeight={fontWeight}
    >
      {children}
    </Typography>
  );
}

export const supportedIngressSizes = ['lg', 'md', 'sm'] as const;

export type SupportedIngressSize = ArrayElementType<
  typeof supportedIngressSizes
>;

export const supportedIngressColors = [
  'gray400',
  'gray500',
  'gray800',
] as const;

export type SupportedIngressColor = ArrayElementType<
  typeof supportedIngressColors
>;

export default Ingress;
